export const CONNECTOR_OPTIONS = [
  { id: "ccs2", label: "CCS2" },
  { id: "type2", label: "Type 2" },
  { id: "bharat_ac_001", label: "Bharat AC-001" },
  { id: "bharat_dc_001", label: "Bharat DC-001" },
];

const MAP = Object.fromEntries(CONNECTOR_OPTIONS.map((c) => [c.id, c.label]));

export const connectorLabel = (id) => MAP[id] || id;
export const connectorLabels = (ids) => (ids || []).map(connectorLabel).join(", ");

export const ACCESS_TYPES = ["Public", "Restricted", "Private"];
